/**
 * Copyright (c) 2016-2020 Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti
 * All Rights Reserved.
 *
 * The software and data contained herein are confidential and
 * proprietary information of Yega Yazilim ("Confidential Information").
 *
 * Users of this software may not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement
 * they entered into with Yega Yazilim.
 *
 *
 * Author    Ahmet Dogramaci
 * Date      2020-03-17
 */
import WatchExpression from "../enums/watch-expression";
import IsDefault from "../enums/is-default";

class ConfigurationTemplateOrGroupWatch {
    constructor() {
        this.watch_expression   = WatchExpression.IS_SELECTED;
        this.is_default         = IsDefault.NO;
        this.node_object        = null;
        this.or_group_object    = null;
    }

    buildFromJson(json_object){
        this.id                 = json_object.id;
        this.watch_expression   = json_object.watch_expression;
        this.is_default         = json_object.is_default;
        this.node               = this.or_group.template_version.getNodeById(json_object.cfg_template_node_id);
        this.node.addOrGroupWatch(this);
    }

    set node(node_in){
        this.node_object = node_in;
    }

    get node(){
        return this.node_object;
    }

    get or_group(){
        return this.or_group_object;
    }

    set or_group(value){
        this.or_group_object = value;
    }

    get isSelectedExpression(){
        return this.watch_expression === WatchExpression.IS_SELECTED;
    }

    get isUnselectedExpression(){
        return this.watch_expression === WatchExpression.IS_UNSELECTED;
    }

    get isSatisfied(){
        if(this.node_object.isSelected && this.isSelectedExpression){
            return true
        }
        if(this.node_object.isUnselected && this.isUnselectedExpression){
            return true
        }
        return false;
    }

    get isDefault(){
        return this.is_default === IsDefault.YES;
    }

    triggerEvaluation(){
        console.log(`Or group:${this.or_group.name}, watch for Node:${this.node.code} evaluation triggered`);
        this.or_group.useWatch(this);
        if(this.isSatisfied){
            console.log(`Or group:${this.or_group.name}, watch for Node:${this.node.code} undoOtherWatches called`);
            this.or_group.undoOtherWatches(this);
        }
        this.or_group.evaluateStatus();
    }

    executeAction(){
        console.log(`executeAction Or group:${this.or_group.name}, watch for Node:${this.node.code}`);
        switch (this.watch_expression) {
            case WatchExpression.IS_SELECTED:
                this.node.addTrace(`Or Group:${this.or_group.name}, executing action for node:${this.node.code},action: select()`);
                this.node.select();
                break;
            case WatchExpression.IS_UNSELECTED:
                this.node.addTrace(`Or Group:${this.or_group.name}, executing action for node:${this.node.code},action: unselect()`);
                this.node.unselect();
                break;
            case WatchExpression.IS_ENABLED:
                this.node.addTrace(`Or Group:${this.or_group.name}, executing action for node:${this.node.code},action: enable()`);
                this.node.enable();
                break;
            case WatchExpression.IS_DISABLED:
                this.node.addTrace(`Or Group:${this.or_group.name}, executing action for node:${this.node.code},action: disable()`);
                this.node.disable();
                break;
            case WatchExpression.IS_HIDDEN:
                this.node.addTrace(`Or Group:${this.or_group.name}, executing action for node:${this.node.code},action: hide()`);
                this.node.hide();
                break;
            case WatchExpression.IS_VISIBLE:
                this.node.addTrace(`Or Group:${this.or_group.name}, executing action for node:${this.node.code},action: show()`);
                this.node.show();
                break;
        }
    }

    undoAction(){
        console.log(`undoAction Or group:${this.or_group.name}, watch for Node:${this.node.code}`);
        switch (this.watch_expression) {
            case WatchExpression.IS_SELECTED:
                this.node.addTrace(`Or Group:${this.or_group.name}, executing reverse action for node:${this.node.code},action: unselect()`);
                this.node.unselect();
                break;
            case WatchExpression.IS_UNSELECTED:
                this.node.addTrace(`Or Group:${this.or_group.name}, executing reverse action for node:${this.node.code},action: select()`);
                this.node.select();
                break;
            case WatchExpression.IS_ENABLED:
                this.node.addTrace(`Or Group:${this.or_group.name}, executing reverse action for node:${this.node.code},action: disable()`);
                this.node.disable();
                break;
            case WatchExpression.IS_DISABLED:
                this.node.addTrace(`Or Group:${this.or_group.name}, executing reverse action for node:${this.node.code},action: enable()`);
                this.node.enable();
                break;
            case WatchExpression.IS_HIDDEN:
                this.node.addTrace(`Or Group:${this.or_group.name}, executing reverse action for node:${this.node.code},action: show()`);
                this.node.show();
                break;
            case WatchExpression.IS_VISIBLE:
                this.node.addTrace(`Or Group:${this.or_group.name}, executing reverse action for node:${this.node.code},action: hide()`);
                this.node.hide();
                break;
        }
    }
}
export default ConfigurationTemplateOrGroupWatch;